import { useFetchDealerBasic } from "../../../fetch/userFetch";
import ReadOnlyField from "./readonlyField";

export default function DealerLabel({ accountNumber }) {
    const { data, isLoading } = useFetchDealerBasic(accountNumber);
    return (
        <ReadOnlyField
            title="Dealer Number"
            value={!isLoading && !!data ? `${data?.name} (${data?.accountNumber})` : accountNumber}
            isLoading={isLoading}
        />
    );
}